import React, { useState } from "react";
import "./SettingsPanel.css";
import { TextField, Button } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CircularProgress from "@mui/material/CircularProgress";
import SaveIcon from "@mui/icons-material/Save";

const SettingsPanel = ({ updateAISettings, isLoading, aiSettings }) => {
  const [aiName, setAiName] = useState('Luna');
  const [companyName, setCompanyName] = useState(aiSettings?.companyName);
  const [companyContact, setCompanyContact] = useState(aiSettings?.companyContact);
  const [industry, setIndustry] = useState(aiSettings?.industry);
  const [isSaved, setIsSaved] = useState(false);
  // const [coachingPrice, setCoachingPrice] = useState(
  //   "try plan for 5 days at 0€/month then 59eu/month, start-up plan for 29€/month, pro plan for 49€/month"
  // );
  const [companyURL, setCompanyURL] = useState(aiSettings?.websiteUrl);
  // const [companyProductURL, setCompanyProductURL] = useState(
  //   "https://www.ecom-legacy.com/coaching"
  // );
  const [companyDetails, setCompanyDetails] = useState(
    aiSettings?.companyDescription
  );
  const user = JSON.parse(localStorage.getItem("user"));

  const handleSubmit = (e) => {
    e.preventDefault();
    updateAISettings(
      {
        aiName,
        companyName,
        industry,
        // coachingPrice,
        websiteUrl: companyURL,
        // companyProductURL,
        companyDescription: companyDetails,
        companyContact,
      },
      user,
      () => {
        // Set isSaved to true on successful save
        setIsSaved(true);

        // Reset isSaved back to false after 3 seconds
        setTimeout(() => {
          setIsSaved(false);
        }, 3000);
      }
    );
  };

  return (
    <div className="SettingsPanel">
      <form onSubmit={handleSubmit} className="setting-col-1">
        <h2
          className="setting_header"
          style={{ textAlign: "center", margin: "50px" }}
        >
          Manage Prompt
        </h2>
        <TextField
          label="AI Name"
          variant="outlined"
          className="setting_input"
          type="text"
          value={aiName}
          disabled={user?.role !== "admin"}
          onChange={(e) => setAiName(e.target.value)}
          InputProps={{
            style: { color: "white", background: 'transparent' },
          }}
          InputLabelProps={{
            style: { color: "rgb(255 255 255 / 60%)" },
          }}
          id="outlined-basic"
          color="secondary"
        />
        <br />

        <TextField
          className="setting_input"
          type="text"
          label="Company Name"
          variant="outlined"
          value={companyName}
          onChange={(e) => setCompanyName(e.target.value)}
          InputProps={{
            style: { color: "white", background: 'transparent' },
          }}
          InputLabelProps={{
            style: { color: "rgb(255 255 255 / 60%)" },
          }}
          id="outlined-basic"
          color="secondary"
        />

        <br />

        <TextField
          className="setting_input"
          type="text"
          label="Industry"
          variant="outlined"
          value={industry}
          onChange={(e) => setIndustry(e.target.value)}
          InputProps={{
            style: { color: "white", background: 'transparent' },
          }}
          InputLabelProps={{
            style: { color: "rgb(255 255 255 / 60%)" },
          }}
          id="outlined-basic"
          color="secondary"
        />

        <br />

        <TextField
          className="setting_input"
          type="text"
          label="Company URL"
          variant="outlined"
          value={companyURL}
          onChange={(e) => setCompanyURL(e.target.value)}
          InputProps={{
            style: { color: "white", background: 'transparent' },
          }}
          InputLabelProps={{
            style: { color: "rgb(255 255 255 / 60%)" },
          }}
          id="outlined-basic"
          color="secondary"
        />

        <br />
      
        <TextField
          className="setting_input"
          type="text"
          label="Company email"
          variant="outlined"
          value={companyContact}
          onChange={(e) => setCompanyContact(e.target.value)}
          InputProps={{
            style: { color: "white", background: 'transparent' },
          }}
          InputLabelProps={{
            style: { color: "rgb(255 255 255 / 60%)" },
          }}
          id="outlined-basic"
          color="secondary"
        />

        <br />

        <TextField
          className="setting_input"
          type="text"
          label="Introduce your company"
          variant="outlined"
          value={companyDetails}
          onChange={(e) => setCompanyDetails(e.target.value)}
          InputProps={{
            style: { color: "white", background: 'transparent' },
          }}
          InputLabelProps={{
            style: { color: "rgb(255 255 255 / 60%)" },
          }}
          id="outlined-basic"
          color="secondary"
        />

        <div></div>
        <Button
          variant="contained"
          disabled={isLoading || isSaved}
          type="submit"
          style={{
            backgroundColor: isSaved ? "#2dbc47" : "#1976d2",
            color: "white",
            fontWeight: "bold",
            borderRadius: "5px",
            padding: "10px",
            cursor: "pointer",
            position: "relative",
          }}
          endIcon={isLoading ? null : isSaved ? <CheckIcon /> : <SaveIcon />}
        >
          {isSaved ? "Changes saved" : "Save changes"}
          {isLoading && (
            <CircularProgress
              size={24}
              style={{
                display: "inline-flex",
                marginLeft: "8px",
                marginRight: "8px",
                color: "white",
              }}
            />
          )}
        </Button>
      </form>
    </div>
  );
};

export default SettingsPanel;
